import { fontSizes } from '../constants/font-sizes.js';
import { lineHeights } from '../constants/line-heights.js';
var contentTextThemeWeb = {
  fontSizes: fontSizes,
  lineHeights: lineHeights
};
var contentTextThemeNative = {
  fontSizes: fontSizes,
  lineHeights: lineHeights
};
export { contentTextThemeNative, contentTextThemeWeb };